// extracted by mini-css-extract-plugin
export default {"recommended":"RecommendCount_recommended__sC2Da","imgBox":"RecommendCount_imgBox__SMj10"};